module.exports = __webpack_public_path__ + "img/range-arrow.4eaa1021.svg";